import createModal from 'modules/modal';
import DefaultLayout from 'modules/modal/layouts';
import type { VideoPlatformType } from 'components/video/shared/types';
import { useIsDesktop } from 'hooks/responsive';
import VideoPlayer from 'components/video/VideoPlayer';
import { RecoilRoot } from 'recoil';
import VideoPlaylistPlayer from 'components/video/VideoPlaylistPlayer';

let modal;

interface IVideoModal {
    id?: string | number;
    platform: VideoPlatformType;
    url: string;
    autoplayVideos?: IVideoModal[];
}

function VideoModal(props: IVideoModal) {
    const { platform, url, autoplayVideos, id } = props;
    const video = { platform, url, autoplayVideos, id };
    const isDesktop = useIsDesktop();

    return (
        <RecoilRoot>
            {autoplayVideos?.length ? (
                <VideoPlaylistPlayer
                    video={video}
                    muted={!isDesktop}
                    videoContainerClassName="embed-responsive embed-responsive-16by9"
                />
            ) : (
                <VideoPlayer
                    video={video}
                    muted={!isDesktop}
                    videoContainerClassName="embed-responsive embed-responsive-16by9"
                />
            )}
        </RecoilRoot>
    );
}

const theme = {
    backgroundColor: '#000',
    color: '#FFF',
    fill: '#FFF',
    width: '800px'
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (
    createProps = { layout: { component: (props) => <DefaultLayout customTheme={theme} {...props} /> } }
) => {
    modal = createModal(createProps);

    return (props: IVideoModal) => {
        modal({
            open: true,
            content: <VideoModal {...props} />
        });
    };
};
